import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, MapPin, Lock } from 'lucide-react';
import Logo from './Logo';
import { eventInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { href: '#om-os', label: 'Om Os' },
    { href: '#galleri', label: 'Galleri' },
    { href: '#team', label: 'Team' },
    { href: '#sponsorer', label: 'Sponsorer' },
    { href: '#kontakt', label: 'Kontakt' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0f1f15] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-white rounded-full p-2">
                <Logo size={50} />
              </div>
              <div>
                <h3 className="text-xl font-bold">Vejles Juletræsfest</h3>
                <p className="text-white/60 text-sm">For børn i udsatte familier</p>
              </div>
            </div>
            <p className="text-white/70 leading-relaxed max-w-md mb-6">
              Vi skaber magiske øjeblikke for børn, der har brug for lidt ekstra juleglæde. 
              Sammen kan vi gøre en forskel.
            </p>
            <div className="flex items-center gap-2 text-white/60">
              <Heart className="w-4 h-4 text-[#c41e3a]" />
              <span className="text-sm">I samarbejde med BROEN Vejle</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Genveje</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Kontakt</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`mailto:${eventInfo.email}`}
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                >
                  <Mail className="w-5 h-5" />
                  <span className="text-sm">{eventInfo.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  {eventInfo.location}<br />
                  {eventInfo.address}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="py-6 border-t border-white/10">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © {currentYear} Vejles Juletræsfest. Alle rettigheder forbeholdes.
            </p>
            <Link
              to="/login"
              className="flex items-center gap-2 text-white/30 hover:text-white/60 text-sm transition-colors"
            >
              <Lock className="w-3 h-3" />
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
